import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { Source } from '../../models/Source';
import { AuthService } from '../../services/auth.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'result-list-filter',
  standalone: true,
  imports: [
    DatePipe,
    ReactiveFormsModule,
    FormsModule],
  templateUrl: './result-list-filter.component.html',
  styleUrl: './result-list-filter.component.css'
})

export class ResultListFilterComponent implements OnInit {
  UserSource: Source = new Source();
  IsHidden = false;
  first = new Date(2024, 0, 1);
  filterForm = new FormGroup({
    reference: new FormControl(''),
    hospitalNum: new FormControl(''),
    labNumber: new FormControl(''),
    surname: new FormControl(''),
    forename: new FormControl(''),
    email: new FormControl(''),
    dob: new FormControl(''),
    fromDate: new FormControl((this.first).toISOString().substring(0, 10), Validators.required),
    toDate: new FormControl(''),
    testCode: new FormControl('')
  })
  @Output() onFilter = new EventEmitter<any>();
  constructor(private formBulder: FormBuilder, private authService: AuthService) {

  }


  ngOnInit() {
    this.UserSource = this.authService.getLoginSource() || new Source();
    this.buildForm();
  }

  buildForm() {
    //const first = new Date(2024, 0, 1);
    this.filterForm = this.formBulder.group({
      reference: '',
      hospitalNum: '',
      labNumber: '',
      surname: [''],
      forename: [''],
      email: '',
      dob: '',
      fromDate: [(this.first).toISOString().substring(0, 10), Validators.required],
      toDate: '',
      testCode: ''
    });
  }

  filterTestResults(filterData : any) {
    this.onFilter.emit(filterData);
  }
}
